if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.endDate = new Date(this.dataset.endDate).getTime();
      if (!Number(this.endDate)) return;

      window.initLazyScript(this, this.init.bind(this));
    }

    init() {
      this.daysEl = this.querySelector('.js-days');
      this.hoursEl = this.querySelector('.js-hours');
      this.minsEl = this.querySelector('.js-mins');
      this.secsEl = this.querySelector('.js-secs');

      this.timer();
      this.interval = setInterval(this.timer.bind(this), this.second);
    }

    timer() {
      const timeDiff = this.endDate - new Date();

      if (timeDiff < 0) {
        clearInterval(this.interval);
        return;
      }

      let days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
      let hours = Math.floor(timeDiff / (1000 * 60 * 60));
      let mins = Math.floor(timeDiff / (1000 * 60));
      let secs = Math.floor(timeDiff / 1000) - mins * 60;

      
      let d_sec = secs < 10 ? "0" + secs:secs;
      mins = mins - hours * 60
      let d_min = mins < 10 ? "0" + mins:mins;
      hours = hours - days * 24
      let d_hour = hours < 10 ? "0" + hours:hours;
      let d_day = days < 10 ? "0" + days:days;

      this.daysEl.textContent = d_day; 
      this.hoursEl.textContent = d_hour;
      this.minsEl.textContent = d_min;
      this.secsEl.textContent = d_sec;
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}
